import React, { memo } from 'react';
import { Typography } from 'components';
import styles from './styles.module.scss';

interface IPageTitle {
  title: string;
}

export const PageTitle = memo<IPageTitle>(({ title }) => {
  return <Typography.Text className={styles.title}>{title}</Typography.Text>;
});
